import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DynamicComponent } from '../../modules/dynamic-components/dynamic-component.model';
import { ListData } from './list.model';

@Component({
  selector: 'rek-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListComponent implements DynamicComponent {
  @Input() readonly inputData: ListData[];
}
